import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  recipeControllerDeleteRecipe,
  recipeControllerGetRecipe,
  recipeControllerSetRecipe,
} from '@klubovna/api-client';
import { RecipeResponseDto, SetRecipeDto } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RecipeApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  getRecipe(productId: string): Observable<RecipeResponseDto> {
    return recipeControllerGetRecipe(this.http, this.apiConfig.rootUrl, { id: productId })
      .pipe(map(response => response.body as RecipeResponseDto));
  }

  setRecipe(productId: string, body: SetRecipeDto): Observable<RecipeResponseDto> {
    return recipeControllerSetRecipe(this.http, this.apiConfig.rootUrl, { id: productId, body })
      .pipe(map(response => response.body as RecipeResponseDto));
  }

  deleteRecipe(productId: string): Observable<void> {
    return recipeControllerDeleteRecipe(this.http, this.apiConfig.rootUrl, { id: productId })
      .pipe(map(() => undefined));
  }
}
